module.exports = function(app){
    app.directive('starRating', function(){

        return{
            restrict: 'A',
            replace: false,
            scope: {
                starRating: '=',
                outOf: '=?'
            },
            controller: ['$scope', function($scope){
                //set defaults
                $scope.outOf = $scope.outOf || 5;
            }],
            link: function(scope, element){
                var html='', i;

                for (i=0; i < scope.outOf; i++){
                    if((i < scope.starRating) && (scope.starRating-i>=0.7)){
                        html += '<span style="position: relative; display: inline-block;"><span class="hm-icon icon-full-star-yellow"></span><span class="hm-icon icon-black-star-outline"></span></span>';
                    }
                    else if((i < scope.starRating) && (scope.starRating-i>=0.3)){
                        html += '<span style="position: relative; display: inline-block;"><span class="hm-icon icon-half-star-yellow"></span><span class="hm-icon icon-black-star-outline"></span></span>';
                    }
                    else{
                        html += '<span style="position: relative; display: inline-block;"><span class="hm-icon icon-full-star-white"></span><span class="hm-icon icon-black-star-outline"></span></span>';
                    }
                }

                element.append(angular.element(html));
            }
        };
    });
};